/* tslint:disable */

declare var Object: any;
export interface RegistrationNewInterface {
  "id"?: number;
}

export class RegistrationNew implements RegistrationNewInterface {
  "id": number;
  constructor(data?: RegistrationNewInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `RegistrationNew`.
   */
  public static getModelName() {
    return "RegistrationNew";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of RegistrationNew for dynamic purposes.
  **/
  public static factory(data: RegistrationNewInterface): RegistrationNew{
    return new RegistrationNew(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'RegistrationNew',
      plural: 'RegistrationNews',
      path: 'RegistrationNews',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/RegistrationNew.ts